module.exports = __webpack_public_path__ + "img/beer_id-75.a33ac8f4.png";